import { delay } from "@formant/core/common/delay";

export const animate = () => delay(200);
